module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-content-block', {
    staticClass: "cta-payment"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('message.paymentCtaUpgrade')))]), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('mu-icon', {
    attrs: {
      "value": "check"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "media-right"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('message.paymentCtaEducation')) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('mu-icon', {
    attrs: {
      "value": "check"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "media-right"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('message.paymentCtaCommunitySupport')) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('mu-icon', {
    attrs: {
      "value": "check"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "media-right"
  }, [_vm._v("\n     " + _vm._s(_vm.$t('message.paymentCtaResources')) + "\n\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('mu-icon', {
    attrs: {
      "value": "check"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "media-right"
  }, [_vm._v("\n     " + _vm._s(_vm.$t('message.paymentCtaMealPlans')) + "\n\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('mu-icon', {
    attrs: {
      "value": "check"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "media-right"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('message.paymentCtaUpdatesInformation')) + "\n\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('mu-icon', {
    attrs: {
      "value": "check"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "media-right"
  }, [_vm._v("\n     " + _vm._s(_vm.$t('message.paymentCtaFriendlySupport')) + "\n    ")])]), _vm._v(" "), _c('mu-raised-button', {
    staticStyle: {
      "margin-top": "8px",
      "margin-bottom": "8px"
    },
    attrs: {
      "fullWidth": "",
      "label": _vm.$t('message.labelUpgrade')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToPayment.apply(null, arguments)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14d0511c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PaymentCTA/PaymentCallToAction.vue
// module id = 3610
// module chunks = 1